import moment from "moment";
import React from "react";
import { Modal, ModalBody } from "reactstrap";

import { ReactComponent as CloseIcon } from "../../../../../../assets/img/svg/CloseIcon.svg";

import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import CustomCopyToClipboard from "views/pages/manage/common/ACopyToClipboard/CustomCopyToClipboard";
import { getTestMediumDisplayValue } from "../../testsListView/constant";
import TestSyllabus from "../../testsListView/TestSyllabus";

import commonStyles from "../../common/commonStyles.module.css";

const ViewTestDetails = ({ isOpen, onClose, viewTest }) => {
  const [isShowSyllabus, setIsShowSyllabus] = React.useState(false);

  const getTime = (date) => {
    return new moment(date).format("hh:mm A");
  };

  const getFormattedDate = (date) => {
    return new moment(date).format("DD MMM YYYY");
  };

  const timeSlot = () => {
    return viewTest?.mode === "Offline"
      ? `${getTime(viewTest?.testStartTime)} - ${getTime(viewTest.testEndTime)}`
      : `${getFormattedDate(viewTest?.onlineTestDate || viewTest?.testDate)} -
          ${getFormattedDate(viewTest?.onlineTestEndDate)}`;
  };

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={onClose}
      style={{ width: "500px" }}
    >
      <ModalBody>
        <div className="d-flex justify-content-between align-items-start mb-1">
          <div className="heading-4 label-color text-bold">
            {viewTest?.testType}
          </div>
          <CloseIcon onClick={() => onClose()} />
        </div>
        <div className="mb-3">
          <CustomChip textColor="#262626" bgColor={"#F5F5F5"}>
            <span>{viewTest?.testName}</span>
            <CustomCopyToClipboard textToCopy={viewTest?.testName} />
          </CustomChip>
          {viewTest?.isTimeTableEvent && (
            <CustomChip
              text="Branch test"
              textColor="#183DD3"
              bgColor="#CCD9FC"
              style={{ marginLeft: "1rem" }}
            />
          )}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Test Date:{" "}
          </span>
          {getFormattedDate(viewTest?.testDate)}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Mode:{" "}
          </span>
          {viewTest?.mode}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Test Format:{" "}
          </span>
          {viewTest?.format}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Result Date:{" "}
          </span>
          {getFormattedDate(viewTest?.resultDate)}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Slot:{" "}
          </span>
          {timeSlot()}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Test medium:{" "}
          </span>
          {viewTest?.mode === "Offline"
            ? "NA"
            : getTestMediumDisplayValue(viewTest?.testMediumType) || "-"}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Room:{" "}
          </span>
          {viewTest?.mode === "Online" ? "NA" : viewTest.room.label}
        </div>

        <div>
          <p
            className={commonStyles.link_button}
            onClick={() => setIsShowSyllabus(!isShowSyllabus)}
          >
            {isShowSyllabus ? "Hide Test Syllabus" : "View Test Syllabus"}
          </p>
          {isShowSyllabus && (
            <TestSyllabus testData={viewTest} isTimetable={true} />
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ViewTestDetails;
